import { get } from 'lodash';
import React from 'react';
import { useHistory } from 'react-router';
import { useParams } from 'react-router-dom';
import { useI18n } from 'src/hooks/useRouterChange';
import _TopLeft from 'src/layout/EditorPageLayout/GoBackAndBreadCrumb/GoBackAndBreadCrumb';
import { i18nGet } from 'src/tools/tools';

const TopLeft = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  // const { name } = props;
  const s = useParams();
  // const uuid = get(s, 'uuid');
  const customerDatabaseUuid = get(s, 'customerDatabaseUuid');
  const h = useHistory();
  const goBack = () => {
    h.push(`/customerDatabase/tagList/${customerDatabaseUuid}`);
  };

  const b = [
    {
      url: '/',
      name: getI18n('general.sider.home'),
    },
    {
      url: '/customerDatabase',
      name: getI18n('customerList.customerDetail_config.customerDatabase'),
    },
    {
      url: `/customerDatabase/tagList/${customerDatabaseUuid}`,
      name: getI18n('customerList.customerTag.customerTag'),
    },
    // {
    //   url: ``,
    //   name: name,
    // },
  ];
  return <_TopLeft goBack={goBack} breadcrumbData={b} />;
};
export default TopLeft;
